import dynamicLocalization from "@/mixins/dynamic-localization";
import standardRequest from "@/mixins/request/standard";

export default {
  props: {
    formId: {
      type: String,
      required: true,
    },
    transmissionPIN: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      submitted: false,
      error: null,
    };
  },
  mounted() {
    this.verify();
  },
  mixins: [dynamicLocalization, standardRequest],
  methods: {
    verify() {
      const pin = parseInt(this.transmissionPIN);

      this.standardRequest(
        {
          method: "POST",
          data: {
            formId: this.formId,
            transmissionPIN: pin,
          },
        },
        `form/verify`,
        (res) => {
          this.submitted = true;
        },
        (err) => {
          console.error("An Error!", err, err.response);

          if (err.response && err.response.data && err.response.data.msg)
            this.error = err.response.data.msg;
          else if (err.response && err.response.data)
            this.error = err.response.data;
        }
      );
    },
  },
};
